import { Card, CardContent } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { Inbox } from "lucide-react"

interface EmptyStateProps {
  title: string
  description: string
  actionLabel?: string
  onAction?: () => void
  icon?: React.ReactNode
}

export function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
  icon,
}: EmptyStateProps) {
  return (
    <Card className="bg-card border-border/50 rounded-2xl">
      <CardContent className="p-12 flex flex-col items-center justify-center text-center space-y-6">
        <div className="w-20 h-20 rounded-2xl bg-muted/20 flex items-center justify-center">
          {icon || <Inbox className="w-10 h-10 text-muted-foreground" />}
        </div>
        <div className="space-y-2">
          <h3 className="text-2xl font-bold text-foreground">{title}</h3>
          <p className="text-muted-foreground max-w-md">{description}</p>
        </div>
        {actionLabel && onAction && (
          <Button 
            onClick={onAction}
            className="bg-primary text-primary-foreground hover:bg-primary/90"
          >
            {actionLabel}
          </Button>
        )}
      </CardContent>
    </Card>
  )
}
